module.exports = __webpack_public_path__ + "img/image-3.0174baaa.jpg";